import Typography from "@/elements/Typography";
import Box from "@/elements/Box";
import { useAuth } from "@/context/useAuth";
import ModelliFiltroTableCard from "@/components/ConfigurazionePage/ModelliFiltroTableCard";
import {
  useGetDescrizioniBonifica,
  useGetDescrizioniManutenzione,
  useGetModelliFiltro,
  useGetModelliOlio,
  useGetNodoIcone,
} from "@/api";
import Loading from "@/components/Loading";
import LoadingError from "@/components/LoadingError";
import ModelliOlioTableCard from "@/components/ConfigurazionePage/ModelliOlioTableCard";
import DescrizioniBonificaTableCard from "@/components/ConfigurazionePage/DescrizioniBonificaTableCard";
import NodoIconeTableCard from "@/components/ConfigurazionePage/NodoIconeTableCard";
import DescrizioniManutenzioneTableCard from "./DescrizioniManutenzioneTableCard";

export default function ConfigurazionePage() {
  const { hasPermission } = useAuth();

  const {
    isLoading: isLoadingModelliFiltro,
    data: modelliFiltro,
    error: errorModelliFiltro,
  } = useGetModelliFiltro();
  const {
    isLoading: isLoadingModelliOlio,
    data: modelliOlio,
    error: errorModelliOlio,
  } = useGetModelliOlio();
  const {
    isLoading: isLoadingDescrizioniBonifica,
    data: descrizioniBonifica,
    error: errorDescrizioniBonifica,
  } = useGetDescrizioniBonifica();
  const {
    isLoading: isLoadingDescrizioniManutenzione,
    data: descrizioniManutenzione,
    error: errorDescrizioniManutenzione,
  } = useGetDescrizioniManutenzione();

  const canManageNodoIcone = hasPermission("NodoIconeChange");
  const {
    isLoading: isLoadingNodoIcone,
    data: nodoIcone,
    error: errorNodoIcone,
  } = useGetNodoIcone({
    query: {
      enabled: canManageNodoIcone,
    },
  });

  const isLoading =
    isLoadingModelliFiltro ||
    isLoadingModelliOlio ||
    isLoadingDescrizioniBonifica ||
    isLoadingDescrizioniManutenzione ||
    (canManageNodoIcone && isLoadingNodoIcone);
  if (isLoading) {
    return <Loading />;
  }

  const error =
    errorModelliFiltro ||
    errorModelliOlio ||
    errorDescrizioniBonifica ||
    errorDescrizioniManutenzione ||
    (canManageNodoIcone ? errorNodoIcone : null);
  if (error) {
    return <LoadingError error={error} />;
  }

  return (
    <Box p={2}>
      <Box
        display="flex"
        flexWrap="wrap"
        alignItems="center"
        justifyContent="space-between"
        mb={2}
      >
        <Typography variant="h4" mr={2}>
          Configurazione
        </Typography>
      </Box>

      <Box display="flex" flexDirection="column" gap={2}>
        <ModelliFiltroTableCard
          modelliFiltro={modelliFiltro?.data ?? []}
          canEdit={hasPermission("ModelliFiltroChange")}
        />

        <ModelliOlioTableCard
          modelliOlio={modelliOlio?.data ?? []}
          canEdit={hasPermission("ModelliOlioChange")}
        />

        <DescrizioniBonificaTableCard
          descrizioniBonifiche={descrizioniBonifica?.data || []}
          canEdit={hasPermission("DescrizioniBonificaChange")}
        />

        <DescrizioniManutenzioneTableCard
          descrizioniManutenzioni={descrizioniManutenzione?.data || []}
          canEdit={hasPermission("DescrizioniManutenzioneChange")}
        />

        {canManageNodoIcone && (
          <NodoIconeTableCard
            nodoIcone={nodoIcone?.data ?? []}
            canEdit={canManageNodoIcone}
          />
        )}
      </Box>
    </Box>
  );
}
